export const GET_COMPANY_CONFIG = "GET_COMPANY_CONFIG";
export const GET_WHITE_STAR_VALUES = "GET_WHITE_STAR_VALUES";
